import React, { Fragment } from 'react';
import { BrowserRouter as Router, Route, Switch, withRouter } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import ScrollToTop from 'components/ScrollToTop';
import DefaultLayout from 'layouts/DefaultLayout';
import { Home, Work, Skills } from 'pages';

const App = ({ location }) => {
  return (
    <ScrollToTop container=".Site__content">
      <DefaultLayout>
        <TransitionGroup component={Fragment}>
          <CSSTransition key={location.pathname} timeout={300} classNames="fade" appear>
            <Switch location={location}>
              <Route path="/" exact component={Home} />
              <Route path="/work" component={Work} />
              <Route path="/skills" component={Skills} />
            </Switch>
          </CSSTransition>
        </TransitionGroup>
      </DefaultLayout>
    </ScrollToTop>
  );
};

const RoutedApp = withRouter(App);

export default () => (
  <Router>
    <RoutedApp />
  </Router>
);



// WEBPACK FOOTER //
// ./src/components/App.js